<template lang="html">
  <div class="editor">
    <el-input
      placeholder="请输入相关内容标题"
      v-model="title"
      clearable>
    </el-input>
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor" class="text">
    </div>
    <div>
      <el-button type="primary" @click="updateAboutMsg">修改信息</el-button>
    </div>
  </div>
</template>

<script>
  import E from 'wangeditor';
  import {getSettingInfo,updateSettingInfo} from  '../../request/api';
  export default {
    name: 'weditor',
    data() {
      return {
        // uploadPath,
        editor: null,
        info_: null,
        title: null
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      isClear: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      isClear(val) {
        // 触发清除文本域内容
        if (val) {
          this.editor.txt.clear()
          this.info_ = null
        }
      },
      value: function(value) {
        if (value !== this.editor.txt.html()) {
          this.editor.txt.html(this.value)
        }
      }
      //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
    },
    mounted() {
      this.seteditor();
      this.loadAboutInfo();
    },
    methods: {
      loadAboutInfo() {
        let param = {
          id: 'aaa'
        }
        getSettingInfo(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.title = resp.data.title
              this.editor.txt.html(resp.data.content)
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      updateAboutMsg() {
        let param = {
          id: 'aaa',
          title: this.title,
          content: this.info_
        }
        updateSettingInfo(param).then(
          resp => {
            if (resp.code === 1) {
              this.$message.success(resp.msg);
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      seteditor() {
        // http://192.168.2.125:8080/admin/storage/create
        this.editor = new E(this.$refs.toolbar, this.$refs.editor);
        //this.editor.config.uploadFileName = 'uFile';
        //this.editor.config.uploadImgServer = this.GLOBAL.urlList.uploadUrl;
        //this.editor.config.uploadImgMaxLength = 1;
        // this.editor.customConfig.uploadImgShowBase64 = false // base 64 存储图片
        // this.editor.customConfig.uploadImgServer = 'http://otp.cdinfotech.top/file/upload_images'// 配置服务器端地址
        // this.editor.customConfig.uploadImgHeaders = { }// 自定义 header
        // this.editor.customConfig.uploadFileName = 'file' // 后端接受上传文件的参数名
        // this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
        // this.editor.customConfig.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
        // this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间

        // 配置菜单
        this.editor.config.menus = [
          'head', // 标题
          'bold', // 粗体
          'fontSize', // 字号
          'fontName', // 字体
          'italic', // 斜体
          'underline', // 下划线
          'strikeThrough', // 删除线
          'foreColor', // 文字颜色
          'backColor', // 背景颜色
          'link', // 插入链接
          'list', // 列表
          'justify', // 对齐方式
          'quote', // 引用
          'emoticon', // 表情
          //'image', // 插入图片
          'table', // 表格
          //'video', // 插入视频
          //'code', // 插入代码
          'undo', // 撤销
          'redo', // 重复
          'fullscreen' // 全屏
        ]
        this.editor.config.onchange = (html) => {
          this.info_ = html // 绑定当前逐渐地值
          this.$emit('change', this.info_) // 将内容同步到父组件中
        }
        // 创建富文本编辑器
        this.editor.create()
      }
    }
  }
</script>

<style lang="css" scoped>
  .editor {
    width: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 0;
  }
  .toolbar {
    border: 1px solid #ccc;
  }
  .text {
    border: 1px solid #ccc;
    min-height: 500px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/syzy/gywm.vue